import classNames from "classnames";

export class ClassNameArray extends Array {
    toString(): string {
        return classNames(this);
    }
}